<div class="content-section" [class.reversed]="reversed">
  <div class="content-section__image">
    <img [src]="imagePath"/>
  </div>
  <div class="content-section__text">
    <div [innerHTML]="content"></div>
    <button mat-flat-button [routerLink]="'/login'" class="is-primary">CLICK TO START</button>
  </div>
</div>
